import sumFilter from "../filters/sum.filter";

/**  Класс для данных авторизации. */
export class CardLimit {
  /**
   * Логин пользователя.
   */
  public Period: number = 0;

  /**
   * Пароль пользователя.
   */
  public SummaCode: string = '';

  /**
   * Новый пароль пользователя.
   * Используется при смене Password.
   */
  public Summa: string = '';

  /**
   * Код подверждения.
   */
  public CountCode: string = '';

  public IndSumma: number = 0;

  public SummaIsReadOnly: boolean = false;

  public CountIsReadOnly: boolean = false;

  public CategoryOrder: number = 0;

  public CategoryCaption: string = '';

  public GlobSumma: number = 0;

  public Currency: string = '';

  public IndCount: number = 0;

  public GlobCount: number = 0;

  public CurrentCount: number = 0;

  /**  Конструктор.
   * @param login Логин
   * @param password Пароль
   * @param newPassword Новый пароль пользователя
   * @param confirmCode Код подверждения
   */
  constructor(src) {
    this.Period = src.Period ?? '';
    this.SummaCode = src.SummaCode ?? '';
    this.Summa = src.CurrentSumma.toString().replace('.', ',') ?? '';
    this.CountCode = src.CountCode ?? '';
    this.IndSumma = src.IndSumma ?? 0; 
    this.CountIsReadOnly = src.CountIsReadOnly ?? false;
    this.SummaIsReadOnly = src.SummaIsReadOnly ?? false;
    this.CategoryCaption = src.CategoryCaption ?? '';
    this.GlobSumma = src.GlobSumma ?? 0;
    this.CategoryOrder = parseInt(src.CategoryOrder) ?? 0;
    this.IndCount = src.IndCount ?? 0;
    this.GlobCount = src.GlobCount ?? 0;
    this.CurrentCount = src.CurrentCount ?? 0;
  }

  get GlobalSumLimitRem(): string {
    return !this.GlobSumma ? 'Не ограничено' : sumFilter(this.GlobSumma, false, this.Currency);
  }

  get GlobalCountLimitStr(): string {
    return !this.GlobCount ? 'Не ограничено' : sumFilter(this.GlobCount);
  }

  get GlobalSumLimitStr(): string {
    return !this.GlobSumma || this.GlobSumma == 0 ? 'Не ограничено' : sumFilter(this.GlobSumma);
  }

  get SumLimit(): string {
    return !this.IndSumma ? sumFilter(this.GlobSumma, false, this.Currency) : sumFilter(this.IndSumma, false, this.Currency);
  }

  get CountStr(): string {
    if (!this.IndCount)
      return sumFilter(this.GlobCount);
    else if (!this.GlobCount)
      return sumFilter(this.IndCount);
    return this.IndCount < this.GlobCount ? sumFilter(this.IndCount) : sumFilter(this.GlobCount);
  }

  get isSum(): boolean {
    return (this.GlobSumma && this.GlobSumma > 0) || (this.IndSumma && this.IndSumma > 0);
  }

  get isCount(): boolean {
    return (this.GlobCount && this.GlobCount > 0) || (this.IndCount && this.IndCount > 0);
  }

  get isPeriod(): boolean {
    return (this.Period == 1 || this.Period == 2) && (this.isSum || this.isCount);
  }

  get isSwitch(): boolean {
    return this.Period == 4;
  }

  get isLimitEditable(): boolean {
    return !this.SummaIsReadOnly && !this.CountIsReadOnly;
  }
}
